import card1Frame1 from "../animations/card1/card1-frame1.svg";
import card1Frame2 from "../animations/card1/card1-frame2.svg";
import card1Frame3 from "../animations/card1/card1-frame3.svg";
import card1Frame4 from "../animations/card1/card1-frame4.svg";
import card1Frame5 from "../animations/card1/card1-frame5.svg";
import card1Frame6 from "../animations/card1/card1-frame6.svg";
import card1Frame7 from "../animations/card1/card1-frame7.svg";
import card1Frame8 from "../animations/card1/card1-frame8.svg";
import card1Frame9 from "../animations/card1/card1-frame9.svg";
import card1Frame10 from "../animations/card1/card1-frame10.svg";
import card1Frame11 from "../animations/card1/card1-frame11.svg";
import card1Frame12 from "../animations/card1/card1-frame12.svg";
import card1Frame13 from "../animations/card1/card1-frame13.svg";
import card1Frame14 from "../animations/card1/card1-frame14.svg";
import card1Frame15 from "../animations/card1/card1-frame15.svg";
import card1Frame16 from "../animations/card1/card1-frame16.svg";


import card2FirstFrame from "../animations/card2/card2-frame1.svg";
import card2SecondFrame from "../animations/card2/card2-frame1.svg";
import card2ThirdFrame from "../animations/card2/card2-frame1.svg";

export const card1Frames = [
  card1Frame1,
  card1Frame2,
  card1Frame3,
  card1Frame4,
  card1Frame5,
  card1Frame6,
  card1Frame7,
  card1Frame8,
  card1Frame9,
  card1Frame10,
  card1Frame11,
  card1Frame12,
  card1Frame13,
  card1Frame14,
  card1Frame15,
  card1Frame16,
];

export const card1Animation = {
  animationName: "card1Keyframes",
  animationDuration: "3s",
  animationTimingFunction: "steps(16, end)", // 16 frames
  animationIterationCount: "infinite",
};

export const card2Animation = {
  animationName: "card2Keyframes",
  animationDuration: "4s",
  animationIterationCount: "infinite",
};

export const cardKeyframes = `
  @keyframes card1Keyframes {
  0%    { content: url(${card1Frame1}); }
  6.66% { content: url(${card1Frame2}); }
  13.33% { content: url(${card1Frame3}); }
  20%   { content: url(${card1Frame4}); }
  26.66% { content: url(${card1Frame5}); }
  33.33% { content: url(${card1Frame6}); }
  40%   { content: url(${card1Frame7}); }
  46.66% { content: url(${card1Frame8}); }
  53.33% { content: url(${card1Frame9}); }
  60%   { content: url(${card1Frame10}); }
  66.66% { content: url(${card1Frame11}); }
  73.33% { content: url(${card1Frame12}); }
  80%   { content: url(${card1Frame13}); }
  86.66% { content: url(${card1Frame14}); }
  93.33% { content: url(${card1Frame15}); }
  100%  { content: url(${card1Frame16}); }
}

  @keyframes card2Keyframes {
    0% { content: url(${card2FirstFrame}); }
    50% { content: url(${card2SecondFrame}); }
    100% { content: url(${card2ThirdFrame}); }
  }
`;
